import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const CircleContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.2);
`;

const CircularImage = ({ img, width, height, ...props }) => {
  return (
    <CircleContainer width={width} height={height} {...props}>
      <img src={img} width="100%" height="100%" alt="" />
    </CircleContainer>
  );
};

CircularImage.propTypes = {
  height: PropTypes.string,
  img: PropTypes.string.isRequired,
  width: PropTypes.string,
};

CircularImage.defaultProps = {
  img: "",
  width: "50px",
  height: "50px",
};

export default CircularImage;
